import { render, staticRenderFns } from "./subjectResearchList.vue?vue&type=template&id=1d2b2bf3&scoped=true&"
import script from "./subjectResearchList.vue?vue&type=script&lang=js&"
export * from "./subjectResearchList.vue?vue&type=script&lang=js&"
import style0 from "./subjectResearchList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./subjectResearchList.vue?vue&type=style&index=1&id=1d2b2bf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2b2bf3",
  null
  
)

export default component.exports